/**
 * ClassicLayout - The standard event/membership detail page layout
 *
 * Composes all classic sections in the correct order.
 * Handles both standard (default) and attraction variants internally.
 *
 * Variants:
 * - default: Standard event/membership layout with modal-based ticket selection
 * - attraction: Inline ticket selection with section-based tabs
 *
 * Note: StickyTabs handles both variants internally via `isAttraction` flag.
 * Note: Site footer is rendered by PublicPage (outside layout) but inside PageThemeProvider.
 */
import { gridSpans } from "@shared/theme/props/grid";
import type { PageData } from "../../adapters/types";
import { LandingPageLayout } from "../shared/LandingPageLayout/LandingPageLayout.web";
import { Header } from "./sections/Header.web";
import { StickyTabs } from "./sections/StickyTabs.web";
import { Footer } from "./sections/Footer.web";
import { Modals } from "./sections/Modals.web";
import { Features } from "./sections/Features.web";
import { PageMainContent } from "../shared/MainContent/PageMainContent.web";

interface ClassicLayoutProps {
  data: PageData;
}

export function ClassicLayout({ data }: ClassicLayoutProps) {
  return (
    <LandingPageLayout
      modals={<Modals data={data} />}
      features={<Features data={data} />}
      headerContent={<Header data={data} />}
      stickyHeader={<StickyTabs data={data} />}
      main={<PageMainContent data={data} colSpan={gridSpans.main} />}
      footer={<Footer data={data} />}
    />
  );
}
